export const STORAGE_KEYS = {
  USER_REGION: 'userRegion',
  USER_OBJ: 'user'
}
